import { useEffect, useState } from 'react';
import { t } from 'i18next';

import { useQueryParams } from '@pocapan/shared/utils/useQueryParams';
import { getSpotsCategoryLocaleValue } from '@pocapan/shared/utils/spotsHelper';

import StickyHeader from '../../../components/StickyHeader';
import { useLocationsQuery } from '../../../components/api/queries/useLocationsQuery';
import { ReportFootprintBreadcrumb } from '../../../components/report/ReportFootprintBreadcrumb';
import StepComponent from '../../../components/steps/StepComponent';
import EventReportBox from '../../../presentation/components/event-detail/EventReportBox';

import { Button } from '@peacecover/component';
import { BaseLocationEvent } from '../../../domain/models/locations/BaseLocationEvent';
import type { ILocationItemResponseBody } from '../../../types/response/ILocationItemResponseBody';

export default function ReportEventsPage() {
  const { queryParams, updateQueryParams, removeQueryParams } = useQueryParams();
  const kakaoUID = queryParams.get('kakaoUID') || '';
  const category = queryParams.get('spotsCategory') || '';
  const artistId = queryParams.get('artistId') || '';
  const spotsCategory = getSpotsCategoryLocaleValue(category);

  const [location, setLocation] = useState<ILocationItemResponseBody>();

  const { data: locationData } = useLocationsQuery({
    kakaoUID: kakaoUID,
    siteTypes: [category],
    artistId: artistId
  });

  useEffect(() => {
    if (locationData && locationData.locations.length > 0) {
      setLocation(locationData.locations[0]);
    }
  }, [locationData]);

  const navigateAddEvent = () => {
    updateQueryParams({ kakaoUID }, '/report-location/events/new');
  };

  return (
    <>
      <StickyHeader
        title={t('ReportEventsPage.pageTitle', { defaultValue: '제보하기' }) as string}
        alwaysShowTitle={true}
        showBackButton={true}
        showTitle={true}
        onClickBackButton={() =>
          removeQueryParams(['locationName', 'kakaoUID'], '/report-location/search-location')
        }
      />
      <div className="flex flex-col pt-[calc(54px+env(safe-area-inset-top))] pb-[calc(128px+env(safe-area-inset-bottom))]">
        <div className="px-[24px] py-[10px]">
          <StepComponent currentStep={0} nextStep={1} maxStep={2} title="">
            <div className="flex flex-col gap-[18px]">
              <div className="mx-[-24px]">
                <ReportFootprintBreadcrumb />
              </div>
              <div className="flex flex-col gap-[14px]">
                <div className="text-[26px] font-bold whitespace-pre-wrap leading-tight text-text-main-lv1">
                  {t('ReportEventsPage.title', {
                    spotsCategory: spotsCategory,
                    defaultValue: '이미 등록된건 아닌지\n한 번 더 확인해주세요.'
                  })}
                </div>
              </div>
            </div>
            {/* 검색 결과 리스트 */}
            <div className="mt-[26px] flex flex-col items-center gap-[16px]">
              {location?.events?.map((event) => (
                <div key={event.eventId}>
                  <EventReportBox event={BaseLocationEvent.fromResponse(event)} />
                </div>
              ))}
            </div>
            <Button
              size="large"
              btnColor="secondary"
              onClick={navigateAddEvent}
              className="mt-[16px] w-full text-[17px] font-semibold"
            >
              {t('ReportEventsPage.createEvent', {
                defaultValue: '없어요, 새로 등록할게요.'
              })}
            </Button>
          </StepComponent>
        </div>
      </div>
    </>
  );
}
